import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import type { IStyle } from '@fluentui/style-utilities';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPaletteAsRawColors, getPalette } from 'owa-theme';
import type { IDropdownStyles } from '@fluentui/react/lib/Dropdown';

const generateDefaultDropdownStyles = (
    colors: ColorScheme,
    overrides?: any
): Partial<IDropdownStyles> => {
    if (!colors) {
        return null;
    }

    const selectedColor = colors.calLighter;
    const selectedTextColor = getOptimalTextColorString(
        selectedColor,
        colors,
        getPaletteAsRawColors().black
    );

    const root: IStyle = [
        {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            flex: '0 0 auto',
            flexDirection: 'row',
            overflow: 'hidden',
            padding: '1px 1px 1px 0px',
        },
        overrides ? overrides.root : null,
    ];

    const label: IStyle = [
        {
            padding: '0px',
            fontSize: '14px',
            height: '20px',
            lineHeight: '18px',
            flexShrink: '0',
        },
        overrides ? overrides.label : null,
    ];

    const dropdown: IStyle = [
        {
            overflow: 'hidden',
            selectors: {
                '&:focus:after': {
                    border: 'none !important',
                },
            },
        },
        overrides ? overrides.dropdown : null,
    ];

    const dropdownItemStyle: IStyle = [
        {
            paddingLeft: '6px',
        },
        overrides ? overrides.dropdownItemStyle : null,
    ];

    const dropdownItemSelected: IStyle = [
        ...dropdownItemStyle,
        {
            backgroundColor: selectedColor + ' !important', // Override Fabric theme color !important
            color: selectedTextColor + ' !important', // Override Fabric theme color !important
            selectors: {
                '&:hover': {
                    color: colors.calDark + ' !important', // Override Fabric theme color !important
                },
            },
        },
        overrides ? overrides.dropdownItemSelected : null,
    ];

    const dropdownItemDisabled: IStyle = [
        {
            paddingLeft: '6px',
        },
        overrides ? overrides.dropdownItemDisabled : null,
    ];

    const title: IStyle = [
        {
            borderWidth: '0px',
            backgroundColor: 'transparent',
            color: getPalette().neutralPrimary + '!important', // override Fabric color when title is placeHolder
            paddingLeft: '6px',
            paddingRight: '28px',
            height: '20px',
            lineHeight: '18px',
            selectors: {
                '&:hover': {
                    color: getPalette().neutralDark + '!important', // override the above !important statement when being hovered
                },
            },
        },
        overrides ? overrides.title : null,
    ];

    const caretDownWrapper: IStyle = [
        {
            height: '20px',
            lineHeight: '18px',
            right: '8px',
        },
        overrides ? overrides.caretDownWrapper : null,
    ];

    const dropdownItems: IStyle = [overrides ? overrides.dropdownItems : null];

    return {
        root: root,
        label: label,
        dropdown: dropdown,
        title: title,
        caretDownWrapper: caretDownWrapper,
        dropdownItem: dropdownItemStyle,
        dropdownItemSelected: dropdownItemSelected,
        dropdownItemDisabled: dropdownItemDisabled,
        dropdownItems: dropdownItems,
    };
};

export default generateDefaultDropdownStyles;
